async function getProducts(args) {
    const params = new URLSearchParams();
    if (args) {
        const {page, filterCategoryId, sort, show, types} = args;
        if (page && (page > 1)) {
            params.append('page', page);
        }
        if (filterCategoryId && (filterCategoryId.length > 0)) {
            params.append('filterCategoryId', filterCategoryId.toString());
        }
        if (sort && (sort.length > 0)) {
            params.append('sort', sort.toString());
        }
        if (show) {
            params.append('show', show.toString());
        }
        if (types) {
            params.append('types', types.toString());
        }
    }
    const queryString = params.toString();
    const url = process.env.REACT_APP_API_BASE_URL + `/index.php?route=api/home/marketplace&${queryString}`;
    try {
        const response = await fetch(url);
        if (!response.ok) {
            console.error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('There was a problem with your fetch operation:', error);
        throw error;
    }
}


async function addToCart(productId) {
    try {
        const response = await fetch(process.env.REACT_APP_API_BASE_URL + '/index.php?route=checkout/cart/add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: 'product_id=' + productId
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error('An error occurred while adding a product to the cart: ' + errorText);
        }

        const data = await response.json();

        if (data.success) {
            return data;
        } else {
            return { error: { warning: 'You have already added this product to your shopping cart.' } };
        }
    } catch (error) {
        console.error('Error:', error);
        return { error: { warning: error.message } };
    }
}


async function addToWishlist(productId) {
    try {
        const response = await fetch(process.env.REACT_APP_API_BASE_URL + '/index.php?route=account/wishlist/add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: 'product_id=' + productId
        });
        if (!response.ok) {
            console.error(response.error);
        }
        const data = await response.json();
        if (data.success) {
            return data;
        } else {
            console.error(data.error);
        }
    } catch (error) {
        alert(error.message);
        return null;
    }
}

async function addFreeToCart(productId) {
        const response = await fetch(process.env.REACT_APP_API_BASE_URL +'/index.php?route=custom/custom/getit', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: 'product_id=' + productId
    });
    return await response.json();
}

export {
    getProducts, addToCart, addToWishlist, addFreeToCart
};
